import axios from "axios";
import { API_BASE_URL } from "configs/AppConfig";
import history from "../history";
import { AUTH_TOKEN } from "redux/constants/Auth";
import { notification } from "antd";

const service = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

const WHITELIST_ERROR_ENDPOINTS = [
  'client_balance/client',
  'refuelings/assets',
  'refuelings',
  'clients',
  'profile_card',
];

// Config ya sirve dice, no, que si
const ENTRY_ROUTE = "/auth/login";
const TOKEN_PAYLOAD_KEY = "authorization";

// API Request interceptor
service.interceptors.request.use(
  (config) => {
    const jwtToken = localStorage.getItem(AUTH_TOKEN);

    if (jwtToken) {
      config.headers[TOKEN_PAYLOAD_KEY] = `Bearer ${jwtToken}`;
    }
    config.headers["X-Cpi-Header"] = `6G$7gX&7h!H7A8mc`;
    if (!jwtToken) {
      // history.push(ENTRY_ROUTE)
      // window.location.reload();
    }

    return config;
  },
  (error) => {
    // Do something with request error here
    notification.error({
      message: "Error",
    });
    Promise.reject(error);
  }
);

// API response interceptor
service.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    if (!error.response) return Promise.reject(error);
    
    const { status, data } = error.response;
    const responseMessage = data?.message || error.response.statusText || "Internal Server Error";

    if (status === 401) {
      localStorage.removeItem(AUTH_TOKEN);
      if (!window.location.hash.includes(ENTRY_ROUTE)) {
        notification.error({
          key: 'session-expired',
          message: "Sesión expirada",
          description: "Por favor, inicia sesión de nuevo.",
        });
        window.dispatchEvent(new CustomEvent('auth_session_expired'));
        history.push(ENTRY_ROUTE);
      } else {
        notification.error({
          key: 'unauthorized',
          message: "No tienes autorización",
          description: responseMessage || "Unauthorized",
        });
      }
      return Promise.reject(error);
    }

    const isWhitelisted = WHITELIST_ERROR_ENDPOINTS.some(
      (endpoint) => error.config?.url?.includes(endpoint)
    );
    if (!isWhitelisted) {
      let notificationParam = {
        message: responseMessage,
      };

      if (status === 404) {
        notificationParam.message = "Recurso no encontrado";
      } else if (status === 403) {
        notificationParam.message = "Acceso denegado";
      } else if (status === 422) {
        notificationParam.message = "Datos inválidos";
      } else if (status === 500) {
        notificationParam.message = "Error interno del servidor";
      }

      notification.error(notificationParam);
    }

    return Promise.reject(error);
  }
);

export default service;
